import { useEffect, useMemo, useRef, useState } from "react";
import { Card } from "primereact/card";
import { BreadCrumb } from 'primereact/breadcrumb';
import type { MenuItem } from "primereact/menuitem";
import Table from "../components/table";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { EVENT_TABLE, EventsApiResponse, HEALTH_TIMELINE_TABLE } from "../interfaces/dashboard";
import { Tag } from "primereact/tag";
import { getSeverity } from "../services/util.service";
// import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import DonutChart from "../components/donut-chart";
// import { useQuery } from "@tanstack/react-query";
// import { fetchApi } from "../services/http.service";
// import { Dropdown, type DropdownChangeEvent } from "primereact/dropdown";
// import { APIMapping } from "../constants/api-mapping.cnst";
// import { Skeleton } from "primereact/skeleton";
import { EVENT_CATEGORIES, FIND_TRIPS_TIME, HBL_PA_RESOURCES, HEALTH_CATEGORIES } from "../constants/data.cnst";
import { APIMapping } from "../constants/api-mapping.cnst";
import { useMutation, useQuery } from "@tanstack/react-query";
import { fetchApi } from "../services/http.service";
import { Skeleton } from "primereact/skeleton";
import { IconArrowLeft, IconDownload, IconFileTypeCsv, IconFileTypeXls } from "@tabler/icons-react";
// import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import { useReactToPrint } from "react-to-print";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import LineChart from "../components/line-chart";
import { Menu } from "primereact/menu";


function TripWiseSummary() {
    const eventTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.TRIP_WISE_SUMMARY_EVENTS;
    const healthTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.TRIP_WISE_SUMMARY_HEALTH;
    const navigate = useNavigate();

    const params = new URLSearchParams(window.location.search);
    const tripId = params.get('tripId') as string;
    const fromDate = params.get("fromDate");
    const toDate = params.get("toDate");

    // const [searchParams, setSearchParams] = useSearchParams();

    // useEffect(() => {
    //     if (!searchParams.get("fromDate") || !searchParams.get("toDate"))
    //         handleDateChange([pastMonth, today], 'fromNavigation');
    // }, [searchParams])

    // const fromDate = searchParams.get("fromDate");
    // const toDate = searchParams.get("toDate");

    // const { today, pastMonth } = useMemo(() => {
    //     const t = new Date();
    //     const p = new Date();
    //     p.setMonth(t.getMonth() - 1);
    //     return { today: t, pastMonth: p };
    // }, []);


    const toast = useRef<Toast>(null);
    const [firstEvent, setFirstEvent] = useState(0);
    const [rowsEvent, setRowsEvent] = useState(10);
    // const [isPrinting, setIsPrinting] = useState(false);

    const [firstHealth, setFirstHealth] = useState(0);
    const [rowsHealth, setRowsHealth] = useState(10);
    const [selectedEventInEventsDistributionChart, setSelectedEventInEventsDistributionChart] = useState<string[]>([]);


    const tripWiseSummaryStats = [
        { label: "No. of Events", value: '-', color: "#FFB269", key: "totalEvents" },
        // { label: "No. of Critical Events", value: '-', color: "#EA5455", key: "totalCriticalEvents" },
        { label: "Kavach (km)", value: '-', color: "#EA5455", key: "kavachKmCovered" },
        { label: "Operating Hours", value: '-', color: "#53D28C", key: "tripDuration" },
        { label: "Availability", value: '-', color: "#EA5455", key: "availability" },
    ]

    // trips count api call
    //   const [tripsSummaryQueryParams, setTripsSummaryQueryParams] = useState({
    //     fromDate: formatDateInDDMMYYYY(dates[0]),
    //     toDate: formatDateInDDMMYYYY(dates[1])
    //   });

    const { data: tripSummaryStatisticsData, isFetching: isTripSummaryStatisticsLoading } = useQuery({
        queryKey: ["trips-summary", tripId],
        queryFn: () =>
            fetchApi({
                endpoint: APIMapping.TRIP_SUMMARY_STATISTICS,
                queryParams: { tripId },
                resourceName: HBL_PA_RESOURCES.TRIP_SUMMARY
            }),
        staleTime: 0,
        gcTime: 0,
        enabled: !!tripId
    });

    const tripWiseSummaryStatistics = useMemo(() => {
        if (!tripSummaryStatisticsData?.response) return tripWiseSummaryStats;

        return tripWiseSummaryStats.map(stat => ({
            ...stat,
            value: tripSummaryStatisticsData?.response?.[stat.key] ?? '-',
        }));
    }, [tripSummaryStatisticsData]);

    //   // events api call
    const [eventsQueryParams, setEventsQueryParams] = useState({
        // fromDate: formatDateInDDMMYYYY(dates[0]),
        // toDate: formatDateInDDMMYYYY(dates[1]),
        total_entry_per_page: 10,
        page_num: 1,
        tripId
    });

    const [healthTimelineQueryParams, setHealthTimelineQueryParams] = useState({
        // fromDate: formatDateInDDMMYYYY(dates[0]),
        // toDate: formatDateInDDMMYYYY(dates[1]),
        total_entry_per_page: 10,
        page_num: 1,
        tripId
    });


    const { data: eventsApiResponse, isFetching: isEventApiFetching } = useQuery<EventsApiResponse>({
        queryKey: ["events-timeline", eventsQueryParams],
        queryFn: () =>
            fetchApi({
                endpoint: APIMapping.EVENTS,
                queryParams: eventsQueryParams,
                resourceName: HBL_PA_RESOURCES.TRIP_SUMMARY
            }),
        staleTime: 0,
        gcTime: 0,
        enabled: Boolean(eventsQueryParams.tripId)
    });

    // const eventTableData: EVENT_TABLE[] = EVENTS_TABLE_DATA
    // const healthTableData: HEALTH_TIMELINE_TABLE[] = HEALTH_TIMELINE

    const eventTableData: EVENT_TABLE[] = eventsApiResponse?.response?.data?.map((rowData: EVENT_TABLE) => {
        return {
            ...rowData,
            eventCategory: rowData.eventCategory.replace('_', ' '),
            eventId: rowData.eventId,
            absoluteLocation: rowData.absoluteLocation || 'NA',
            displayEventId: rowData.eventId.substring(0, 5) + '...'
        };
    }) ?? [];

    const totalEvents = eventsApiResponse?.response?.total_entries ?? 0;

    const handleNavigateToFindtrips = () => {
        const searchParams = new URLSearchParams(location.search);

        searchParams.delete("tripId");

        navigate({
            pathname: "/find-trips",
            search: searchParams.toString(),
        });
    };

    const savedTripTime = JSON.parse(localStorage.getItem(FIND_TRIPS_TIME) ?? '{}');

    const parseCustomDate = (str: string) => {
        // "09/02/2026, 11:30:00:000"
        const [datePart, timePart] = str.split(", ");

        const [day, month, year] = datePart.split("/").map(Number);
        const [hh, mm, ss] = timePart.split(":").map(Number);
        return new Date(year, month - 1, day, hh, mm, ss);
    };

    const getInitialTimeResolution = (start: string, end: string) => {
        const startDate = parseCustomDate(start);
        const endDate = parseCustomDate(end);

        const diffMs = Math.abs(endDate.getTime() - startDate.getTime());

        const diffMinutes = diffMs / (1000 * 60);
        const diffHours = diffMinutes / 60;
        if (diffHours >= 1) return "HOUR";   // >= 1 hour
        if (diffMinutes < 10) return "SEC"; // < 10 min

        return "MIN"; // fallback (optional)
    };

    const initialTimeResolution = getInitialTimeResolution(savedTripTime.tripStart, savedTripTime.tripEnd)

    const [rfParams, setRfParams] = useState<{
        locoId: string;
        tripId: string;
        windowStart: string;
        windowEnd: string;
        isRfStrength: '' | boolean;
        timeResolution: string;
        minWindowStart: string;
        minWindowEnd: string;
    }>({
        locoId: savedTripTime.locoId,
        tripId: tripId,
        windowStart: savedTripTime.tripStart || fromDate,
        windowEnd: savedTripTime.tripEnd || toDate,
        isRfStrength: '',
        timeResolution: initialTimeResolution,
        minWindowStart: '',
        minWindowEnd: ''
    });

    const [speedParams, setSpeedParams] = useState({
        locoId: savedTripTime.locoId,
        tripId: tripId,
        windowStart: savedTripTime.tripStart || fromDate,
        windowEnd: savedTripTime.tripEnd || toDate,
        isRfStrength: false,
        timeResolution: initialTimeResolution,
        minWindowStart: '',
        minWindowEnd: ''
    });

    const { data: rfStrengthData, isFetching: isRFStrengthLoading } = useQuery({
        queryKey: ["trips-rf-strength-speed", rfParams],
        queryFn: () =>
            fetchApi({
                endpoint: APIMapping.TRIP_RF_STRENGTH_SPEED,
                queryParams: rfParams,
                resourceName: HBL_PA_RESOURCES.TRIP_SUMMARY
            }),
        staleTime: 0,
        gcTime: 0,
        enabled: !!tripId
    });

    const { data: speedData, isFetching: isSpeedLoading, refetch: fetchSpeedData } = useQuery({
        queryKey: ["trips-rf-strength-speed", speedParams],
        queryFn: () =>
            fetchApi({
                endpoint: APIMapping.TRIP_RF_STRENGTH_SPEED,
                queryParams: speedParams,
                resourceName: HBL_PA_RESOURCES.TRIP_SUMMARY
            }),
        staleTime: 0,
        gcTime: 0,
        enabled: false
    });

    const [initialData, setInitialData] = useState<typeof rfStrengthData>();

    useEffect(() => {
        if (rfStrengthData && initialData === undefined) {
            setInitialData(rfStrengthData);
        }
    }, [rfStrengthData, initialData]);

    const formatChartData = (data: any[] = [], type: "speed" | "rf") => {
        const labels = data.map(d => d.timestamp.split(", ")[1]);

        const formatDate = (date: Date) => {
            const dd = String(date.getDate()).padStart(2, "0");
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const yyyy = date.getFullYear();

            const hh = String(date.getHours()).padStart(2, "0");
            const min = String(date.getMinutes()).padStart(2, "0");
            const ss = String(date.getSeconds()).padStart(2, "0");

            return `${dd}/${mm}/${yyyy}, ${hh}:${min}:${ss}`;
        };

        const values = data.map(d =>
            type === "rf"
                ? d.rfSigStrength
                : d.currentSpeed
        );


        const isAllZero =
            values.length > 0 &&
            values.every((v: number) => v === 0);

        // Radio Hold means RF strength > 5
        const isRadioHole = (value: any) =>
            type === "rf" &&
            value !== null &&
            value !== undefined &&
            Number(value) > 5;

        // midpoint timestamps for tooltip
        const timestamps = data
            .slice(0, -1)
            .map((d, i) => {
                const current = parseCustomDate(d.timestamp);
                const next = parseCustomDate(data[i + 1].timestamp);

                const mid = new Date(
                    (current.getTime() + next.getTime()) / 2
                );

                return formatDate(mid);
            });

        const mainDataset = {
            label:
                type === "rf"
                    ? "Avg RF Strength"
                    : "Avg Speed",

            parsing: false,

            data: [
                // hidden first anchor point
                {
                    x: 0,
                    y: values[0]
                },

                // visible middle points
                ...data.slice(0, -1).map((d, i) => ({
                    x: i + 0.5,
                    y:
                        type === "rf"
                            ? d.rfSigStrength
                            : d.currentSpeed
                })),

                // hidden last anchor point
                {
                    x: data.length - 1,
                    y: values[data.length - 1]
                }
            ],

            // hide first & last marker
            pointRadius: (ctx: any) => {
                const idx = ctx.dataIndex;

                if (
                    idx === 0 ||
                    idx === ctx.dataset.data.length - 1
                ) {
                    return 0;
                }

                return 4;
            },

            pointHoverRadius: 6,

            pointBackgroundColor: "#ffffff",

            // RF: Radio Hold points are red
            // Speed: normal styling
            pointBorderColor: (ctx: any) => {
                if (type !== "rf") {
                    return "#42A5F5";
                }

                const value = ctx.raw?.y;

                return isRadioHole(value)
                    ? "#ef4444"
                    : "#42A5F5";
            },

            pointBorderWidth: 2,

            // Apply dotted red segments only for RF
            ...(type === "rf" && {
                segment: {
                    borderColor: (ctx: any) => {
                        const y1 = ctx.p0?.parsed?.y;
                        const y2 = ctx.p1?.parsed?.y;

                        return isRadioHole(y1) || isRadioHole(y2)
                            ? "#ef4444"
                            : "#42A5F5";
                    },

                    borderDash: (ctx: any) => {
                        const y1 = ctx.p0?.parsed?.y;
                        const y2 = ctx.p1?.parsed?.y;

                        return isRadioHole(y1) || isRadioHole(y2)
                            ? [6, 6]
                            : [];
                    }
                }
            }),

            // align tooltip data with hidden start/end
            tcasMode: [
                [],
                ...data
                    .slice(0, -1)
                    .map(d => d.tcasModes),
                []
            ]
        };

        return {
            labels,

            isAllZero,

            // tooltip timestamps
            timestamps,

            // click/range timestamps
            originalTimestamps: data.map(d => d.timestamp),

            datasets: [
                mainDataset,

                // Radio Hold legend - only for RF chart
                ...(type === "rf"
                    ? [
                        {
                            label: "Radio Hole",
                            data: [],
                            borderColor: "#ef4444",
                            backgroundColor: "#ef4444",
                            borderDash: [6, 6],
                            pointRadius: 0,
                            pointHoverRadius: 0
                        }
                    ]
                    : [])
            ]
        };
    };

    const getTimeResolution = (start: string, end: string) => {
        const startDate = parseCustomDate(start);
        const endDate = parseCustomDate(end);

        const diffMs = Math.abs(endDate.getTime() - startDate.getTime());

        const diffMinutes = diffMs / (1000 * 60);
        const diffHours = diffMinutes / 60;
        if (diffHours >= 1 || diffMinutes > 10) return "MIN";   // >= 1 hour
        if (diffMinutes <= 10) return "SEC"; // <= 10 min

        return "HOUR"; // fallback (optional)
    };

    const handleChartClick = (start: any, end: any, isRf: boolean) => {

        const timeResolution = getTimeResolution(start, end);

        console.log("Selected range:", start, end, isRf, timeResolution);
        if (isRf) {
            if (rfParams.timeResolution === "SEC")
                return;
            setRfParams(prev => ({
                ...prev,
                ...(timeResolution === "SEC" ? { minWindowStart: prev.windowStart, minWindowEnd: prev.windowEnd } : {}),
                windowStart: start,
                windowEnd: end,
                timeResolution,
                isRfStrength: true
            }));
        } else {
            if (speedParams.timeResolution === "SEC")
                return;
            setSpeedParams(prev => ({
                ...prev,
                ...(timeResolution === "SEC" ? { minWindowStart: prev.windowStart, minWindowEnd: prev.windowEnd } : {}),
                windowStart: start,
                windowEnd: end,
                timeResolution,
                isRfStrength: false
            }));
            setTimeout(() => {
                fetchSpeedData();
            }, 100);
        }
    };

    const rfStrengthHeader = (

        <div className="flex justify-between items-center">
            <h3 className="m-0 font-semibold">RF Strength Over Time</h3>

            <div className="flex gap-2">
                {((rfParams.timeResolution === "MIN" || rfParams.timeResolution === "SEC") && initialTimeResolution === 'HOUR') && (
                    <Button
                        className="bg-gray-200 border-gray-200 text-gray-700 dark:bg-gray-700 dark:border-gray-700 dark:text-gray-200"
                        onClick={() => {

                            setRfParams(prev => ({
                                ...prev,
                                windowStart: savedTripTime.tripStart,
                                windowEnd: savedTripTime.tripEnd,
                                timeResolution: "HOUR",
                                isRfStrength: true
                            }));
                        }}
                    >
                        <span>HOUR</span>
                    </Button>
                )}

                {rfParams.timeResolution === "SEC" && (initialTimeResolution === 'HOUR' || initialTimeResolution === 'MIN') && (
                    <Button
                        className="bg-gray-200 border-gray-200 text-gray-700 dark:bg-gray-700 dark:border-gray-700 dark:text-gray-200"
                        onClick={() => {
                            setRfParams(prev => ({
                                ...prev,
                                windowStart: rfParams.minWindowStart,
                                windowEnd: rfParams.minWindowEnd,
                                timeResolution: "MIN",
                                isRfStrength: true
                            }));

                        }}
                    >
                        <span>MIN</span>
                    </Button>
                )}
            </div>
        </div>

    );

    const speedHeader = (

        <div className="flex justify-between items-center">
            <h3 className="m-0 font-semibold">Speed VS Time</h3>

            <div className="flex gap-2">
                {((speedParams.timeResolution === "MIN" || speedParams.timeResolution === "SEC") && initialTimeResolution === 'HOUR') && (
                    <Button
                        className="bg-gray-200 border-gray-200 text-gray-700 dark:bg-gray-700 dark:border-gray-700 dark:text-gray-200"
                        onClick={() => {
                            setSpeedParams(prev => ({
                                ...prev,
                                windowStart: savedTripTime.tripStart,
                                windowEnd: savedTripTime.tripEnd,
                                timeResolution: "HOUR",
                                isRfStrength: false
                            }));
                            setTimeout(() => {
                                fetchSpeedData();
                            }, 100);
                        }}
                    >
                        <span>HOUR</span>
                    </Button>
                )}

                {speedParams.timeResolution === "SEC" && (initialTimeResolution === 'HOUR' || initialTimeResolution === 'MIN') && (
                    <Button
                        className="bg-gray-200 border-gray-200 text-gray-700 dark:bg-gray-700 dark:border-gray-700 dark:text-gray-200"
                        onClick={() => {
                            setSpeedParams(prev => ({
                                ...prev,
                                windowStart: speedParams.minWindowStart,
                                windowEnd: speedParams.minWindowEnd,
                                timeResolution: "MIN",
                                isRfStrength: false
                            }));
                            setTimeout(() => {
                                fetchSpeedData();
                            }, 100);

                        }}
                    >
                        <span>MIN</span>
                    </Button>
                )}
            </div>
        </div>

    );

    const breadcrumb: MenuItem[] = [
        { label: 'Find Trips', style: { fontWeight: 500 }, command: () => handleNavigateToFindtrips() },
        { label: 'Summary', style: { pointerEvents: 'none' }, className: 'font-semibold text-gray-900' }
    ];

    const { data: healthTimelineResponseData, isFetching: isHealthTimelineFetching } = useQuery({
        queryKey: ["health-timeline", healthTimelineQueryParams],
        queryFn: () =>
            fetchApi({
                endpoint: APIMapping.HEALTH_TIMELINE,
                queryParams: healthTimelineQueryParams,
                resourceName: HBL_PA_RESOURCES.TRIP_SUMMARY
            }),
        staleTime: 0,
        gcTime: 0,
        enabled: Boolean(healthTimelineQueryParams.tripId)
    });

    const healthTableData: HEALTH_TIMELINE_TABLE[] = healthTimelineResponseData?.response?.data?.map((rowData: EVENT_TABLE) => {
        return {
            ...rowData,
            // eventCategory: rowData.eventCategory.replace('_', ' '),
            // eventId: rowData.eventId,
            // displayEventId: rowData.eventId.substring(0, 5) + '...'
        };
    }) ?? [];

    const totalHealths = healthTimelineResponseData?.response?.total_entries ?? 0;

    const { data: eventHealthDistributionResponseData, isFetching: isEventHealthDistributionFetching } = useQuery({
        queryKey: ["event-health-distribution", tripId],
        queryFn: () =>
            fetchApi({
                endpoint: APIMapping.EVENTS_HEALTH_DISTRIBUTION,
                queryParams: { tripId },
                resourceName: HBL_PA_RESOURCES.TRIP_SUMMARY
            }),
        staleTime: 0,
        gcTime: 0,
        enabled: !!tripId
    });

    const { data: eventCategoriesResponse, isFetching: isEventCategoriesLoading } = useQuery({
        queryKey: [
            "trip-summary-event",
        ],
        queryFn: () =>
            fetchApi({
                endpoint: APIMapping.GET_EVENT_SUB_CATEGORIES,
                queryParams: { toDate: toDate, fromDate: fromDate, locoIds: savedTripTime.locoId },
                resourceName: HBL_PA_RESOURCES.TRIP_SUMMARY,
            }),
        enabled: Boolean(toDate && fromDate)
    });

    const eventCategoryOptions = useMemo(
        () =>
            eventCategoriesResponse?.response?.map((item: any) => ({
                label: item.eventCategory
                    .replaceAll("_", " ")
                    .replace(/\b\w/g, (c: string) => c.toUpperCase()),
                value: item.eventCategory
            })) ?? [],
        [eventCategoriesResponse]
    );
    //   const { data: eventOverTimeResponseData } = useQuery({
    //     queryKey: ["events-over-time", tripsSummaryQueryParams],
    //     queryFn: () =>
    //       fetchApi({
    //         endpoint: APIMapping.EVENTS_OVER_TIME,
    //         queryParams: tripsSummaryQueryParams
    //       }),
    //     enabled: !!tripsSummaryQueryParams
    //   });

    //   const { data: eventDistributionResponseData } = useQuery({
    //     queryKey: ["events-distribution-by-zone", tripsSummaryQueryParams],
    //     queryFn: () =>
    //       fetchApi({
    //         endpoint: APIMapping.DISTRIBUTION_BY_ZONE,
    //         queryParams: tripsSummaryQueryParams
    //       }),
    //     enabled: !!tripsSummaryQueryParams
    //   });

    //   const getLocoBarChartData = (data: any, key: string) => {
    //     return {
    //       labels: data.map((item: any) => String(item[key])),

    //       datasets: HEALTH_CATEGORIES.map((event) => ({
    //         label: event.label,
    //         backgroundColor: event.backgroundColor,
    //         data: data.map(
    //           (item: any) =>
    //             item?.breakdownByCategory?.[event.key] ?? 0
    //         )
    //       }))
    //     };
    //   };

    //   const periodOptions = useMemo(() => [
    //     {
    //       label: "Day",
    //       value: "Day",
    //       disabled: eventOverTimeResponseData?.response?.day?.length === 0
    //     },
    //     {
    //       label: "Week",
    //       value: "Week",
    //       disabled: eventOverTimeResponseData?.response?.week?.length === 0
    //     },
    //     {
    //       label: "Month",
    //       value: "Month",
    //       disabled: eventOverTimeResponseData?.response?.month?.length === 0
    //     }
    //   ], [eventOverTimeResponseData]);

    //   const [selectedPeriod, setSelectedPeriod] = useState<string | null>(null);
    //   useEffect(() => {
    //     const validOption = periodOptions.find(opt => !opt.disabled);
    //     setSelectedPeriod(validOption?.value ?? null);
    //   }, [eventOverTimeResponseData]);


    //   const getEventOverTimeChartData = (data: any) => {
    //     const period = selectedPeriod?.toLowerCase() || 'day';
    //     const periodData = data?.[period] ?? [];
    //     return {
    //       labels: periodData.map((item: any) => item.timeBucket),

    //       datasets: HEALTH_CATEGORIES.map((event) => ({
    //         label: event.label,
    //         data: periodData.map(
    //           (item: any) =>
    //             item?.categoryBreakdown?.[event.key] ?? 0
    //         ),

    //         fill: false,
    //         borderColor: event.backgroundColor,
    //         tension: 0.4,

    //         // Point styles
    //         pointStyle: "circle",
    //         pointRadius: 6,
    //         pointHoverRadius: 8,
    //         pointBackgroundColor: event.backgroundColor,
    //         pointBorderColor: "#fff",
    //         pointBorderWidth: 2
    //       }))
    //     };
    //   }

    //   const locoBarChartData = getLocoBarChartData(eventsCategoryResponseData?.response?.topLocosByEvents ?? [], 'locoId');
    //   const stationBarChartData = getLocoBarChartData(eventsCategoryResponseData?.response?.topStationsByEvents ?? [], 'stationId');
    //   const eventsOverTimeData = getEventOverTimeChartData(eventOverTimeResponseData?.response ?? []);

    const healthDistributionData = {
        labels: HEALTH_CATEGORIES.map((e) => e.label),

        datasets: [
            {
                data: HEALTH_CATEGORIES.map(
                    (e) => eventHealthDistributionResponseData?.response?.healthDistributionByCategory?.[e.key] ?? 0
                ),

                backgroundColor: HEALTH_CATEGORIES.map(
                    (e) => e.backgroundColor
                ),

                hoverBackgroundColor: HEALTH_CATEGORIES.map(
                    (e) => e.backgroundColor
                ),

                borderWidth: 0
            }
        ]
    };

    const eventsDistributionData = {
        labels: EVENT_CATEGORIES.map((e) => e.label),

        datasets: [
            {
                data: EVENT_CATEGORIES.map(
                    (e) => eventHealthDistributionResponseData?.response?.eventsDistributionByCategory?.[e.key] ?? 0
                ),

                backgroundColor: EVENT_CATEGORIES.map(
                    (e) => e.backgroundColor
                ),

                hoverBackgroundColor: EVENT_CATEGORIES.map(
                    (e) => e.backgroundColor
                ),

                borderWidth: 0
            }
        ]
    };


    const handleEventView = (rowData: any) => {
        const params = new URLSearchParams(location.search);
        params.set("eventId", rowData.eventId);

        navigate(`/dashboard/event-rca?${params.toString()}`);
    };

    const buildFinalPath = (rowData: any) => {
        let path = '/report/loco-health/' + (rowData['parameter'].includes('RF Issues') ? 'rf-issues-loco' : rowData['parameter']).toLowerCase().replace(/\s/g, '-');

        const params = new URLSearchParams();
        if (rowData['locoId'])
            params.append("locoId", rowData['locoId']);

        // if (currentFilters.locoId?.trim()) {
        //     params.append("locoId", currentFilters.locoId.trim());
        // }

        // if (currentFilters.stationId?.trim()) {
        //     params.append("stationId", currentFilters.stationId.trim());
        // }

        if (tripId) {
            params.append("tripId", tripId);
        }

        if (fromDate) {
            params.append("fromDate", fromDate);
        }

        if (toDate) {
            params.append("toDate", toDate);
        }

        navigate(
            params.toString()
                ? `${path}?${params.toString()}` :
                path
        );
    };

    // const { isFetching: isDownloading, refetch: downloader } = useQuery({
    //     queryKey: ["reports-download", tripId],
    //     queryFn: () =>
    //         fetchApi({
    //             endpoint: APIMapping.REPORTS_EXPORT,
    //             responseType: "blob",
    //             queryParams: { format: 'PDF',
    //                 tripId, fromDate, toDate, reportType: 'REPORT_TYPE_EVENTS', eventCategories: selectedEventInEventsDistributionChart?.map((t: string) =>
    //                     t.replaceAll(" ", "_").replaceAll("/", "_").toUpperCase()
    //                 ).join(",")
    //             },
    //             resourceName: HBL_PA_RESOURCES.TRIP_SUMMARY
    //         }),
    //     staleTime: 0,
    //     gcTime: 0,
    //     enabled: false
    // });

    const { mutateAsync: downloadEvents, isPending: isDownloading } = useMutation({
        mutationFn: (format: "CSV" | "EXCEL") =>
            fetchApi({
                endpoint: APIMapping.REPORTS_EXPORT,
                responseType: "blob",
                queryParams: {
                    format,
                    tripId,
                    fromDate,
                    toDate,
                    reportType: "REPORT_TYPE_EVENTS",
                    eventCategories: selectedEventInEventsDistributionChart
                        ?.map((t: string) =>
                            t.replaceAll(" ", "_").replaceAll("/", "_").toUpperCase()
                        )
                        .join(","),
                },
                resourceName: HBL_PA_RESOURCES.TRIP_SUMMARY,
            }),
    });

    const handleDownload = async (format: "CSV" | "EXCEL") => {
        try {
            const result = await downloadEvents(format);
            const blob = result.data as Blob;

            const contentDisposition = result.headers.get("content-disposition");
            let fileName = 'REPORT_TYPE_EVENTS'; // fallback

            if (contentDisposition) {
                console.log(contentDisposition)
                const match = contentDisposition.match(/filename="?([^"]+)"?/);
                if (match?.[1]) {
                    fileName = match[1];
                }
            }

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");

            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();

            a.remove();
            window.URL.revokeObjectURL(url);

            toast.current?.show({
                severity: "success",
                summary: "Success",
                detail: `Events timeline downloaded successfully`,
                life: 3000
            });
        } catch (err) {
            console.error("Download failed", err);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Unable to download event timeline report. Please try again.",
                life: 4000
            });
        }
    };


    // const { isFetching: isHealthTimelineDownloading, refetch: healthTimelineDownloader } = useQuery({
    //     queryKey: ["reports-download", tripId],
    //     queryFn: () =>
    //         fetchApi({
    //             endpoint: APIMapping.REPORTS_EXPORT,
    //             responseType: "blob",
    //             queryParams: { tripId, fromDate, toDate, reportType: 'TRIP_HEALTH_TIMELINE' },
    //             resourceName: HBL_PA_RESOURCES.TRIP_SUMMARY
    //         }),
    //     staleTime: 0,
    //     gcTime: 0,
    //     enabled: false
    // });

    const {
        mutateAsync: downloadHealthTimeline,
        isPending: isHealthTimelineDownloading,
    } = useMutation({
        mutationFn: (format: "CSV" | "EXCEL") =>
            fetchApi({
                endpoint: APIMapping.REPORTS_EXPORT,
                responseType: "blob",
                queryParams: {
                    format,
                    tripId,
                    fromDate,
                    toDate,
                    reportType: "TRIP_HEALTH_TIMELINE",
                },
                resourceName: HBL_PA_RESOURCES.TRIP_SUMMARY,
            }),
    });

    const handleHealthTimelineDownload = async (format: "CSV" | "EXCEL") => {
        try {
            const result = await downloadHealthTimeline(format);
            const blob = result.data as Blob;

            const contentDisposition = result.headers.get("content-disposition");
            let fileName = 'TRIP_HEALTH_TIMELINE'; // fallback

            if (contentDisposition) {
                console.log(contentDisposition)
                const match = contentDisposition.match(/filename="?([^"]+)"?/);
                if (match?.[1]) {
                    fileName = match[1];
                }
            }

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");

            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();

            a.remove();
            window.URL.revokeObjectURL(url);

            toast.current?.show({
                severity: "success",
                summary: "Success",
                detail: `Health timeline downloaded successfully`,
                life: 3000
            });
        } catch (err) {
            console.error("Download failed", err);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Unable to download health timeline report. Please try again.",
                life: 4000
            });
        }
    };

    const eventItems = [
        {
            label: "CSV",
            icon: <IconFileTypeCsv />,
            command: () => { handleDownload("CSV"); }
        },
        {
            label: "Excel",
            icon: <IconFileTypeXls />,
            command: () => { handleDownload("EXCEL"); }
        }
    ];

    const healthItems = [
        {
            label: "CSV",
            icon: <IconFileTypeCsv />,
            command: () => { handleHealthTimelineDownload("CSV"); }
        },
        {
            label: "Excel",
            icon: <IconFileTypeXls />,
            command: () => { handleHealthTimelineDownload("EXCEL"); }
        }
    ];
    const eventsMenu = useRef<Menu>(null);
    const healthMenu = useRef<Menu>(null);

    const eventsTimelineHeader = (
        <div className="flex flex-col gap-2">

            {/* Row 1 */}
            <div className="flex justify-between items-center">
                <h3 className="m-0 font-semibold">Events Timeline</h3>

                <Button
                    label="Download"
                    icon={<IconDownload size={20} />}
                    loading={isDownloading}
                    disabled={isDownloading || eventTableData.length === 0}
                    className="bg-brand-600 border-brand-600 text-white dark:bg-brand-400 dark:border-brand-500"
                    onClick={(event) => eventsMenu.current?.toggle(event)}
                />
                <Menu
                    popup
                    ref={eventsMenu}
                    model={eventItems}
                    id="popup_menu"
                    popupAlignment="right"
                />
            </div>

            {/* Row 2 */}
            <div className="flex justify-end">
                <MultiSelect
                    value={selectedEventInEventsDistributionChart}
                    options={eventCategoryOptions}
                    optionLabel="label"
                    optionValue="value"
                    disabled={isEventCategoriesLoading}
                    onChange={(e) => {
                        const selected = e.value;

                        setSelectedEventInEventsDistributionChart(selected);
                        setFirstEvent(0);
                        setRowsEvent(10);

                        setEventsQueryParams((prev: any) => ({
                            ...prev,
                            eventCategories: selected?.length
                                ? selected?.map((t: string) =>
                                    t.replaceAll(" ", "_").replaceAll("/", "_").toUpperCase()
                                )
                                    .join(",")
                                : null,
                            page_num: 1,
                            total_entry_per_page: 10,
                        }));
                    }}
                    placeholder="Select Events"
                    className="w-66"
                    display="chip"
                    filter
                    resetFilterOnHide
                />
            </div>

        </div>

    );

    const healthTimelineHeader = (
        <>
            <div className="flex justify-between items-center">
                <h3 className="m-0 font-semibold">Health Timeline</h3>

                <Button
                    label="Download"
                    icon={<IconDownload size={20} />}
                    loading={isHealthTimelineDownloading}
                    disabled={isHealthTimelineDownloading || healthTableData.length === 0}
                    className="bg-brand-600 border-brand-600 text-white dark:bg-brand-400 dark:border-brand-500"
                    onClick={(event) => healthMenu.current?.toggle(event)}
                />
                <Menu
                    popup
                    ref={healthMenu}
                    model={healthItems}
                    id="popup_menu"
                    popupAlignment="right"
                />
            </div>
        </>
    );


    const printRef = useRef<HTMLDivElement>(null);

    const handlePrint = useReactToPrint({
        contentRef: printRef,
        documentTitle: `Trip_Summary_${tripId}`,

        onBeforePrint: () =>
            new Promise<void>((resolve) => {


                const isDark = document.documentElement.classList.contains("dark");

                if (isDark) {
                    printRef.current?.classList.add("print-dark");
                }
                // setIsPrinting(true);
                setTimeout(() => {
                    resolve();
                }, 1000);
            }),

        onAfterPrint: () => {
            printRef.current?.classList?.remove("print-dark");
            // setIsPrinting(false);
        },

        onPrintError: (error) => {
            console.error("Print error:", error);
            printRef.current?.classList?.remove("print-dark");
        }
    });

    const getEventColor = (value: string) => {
        return EVENT_CATEGORIES.find(
            (event) => event.label.toUpperCase() === value.replaceAll('_', ' ')
        )?.backgroundColor ?? '#6B7280';
    };



    return (
        <div className="h-[calc(100vh-4rem)] p-6 flex-1 overflow-y-auto">
            <Toast ref={toast} />
            <div className="flex items-center gap-1">
                <IconArrowLeft
                    onClick={() => { handleNavigateToFindtrips(); }}
                    className="cursor-pointer"
                />

                <BreadCrumb model={breadcrumb} />

                <Button
                    label="Download"
                    disabled={isTripSummaryStatisticsLoading || isEventHealthDistributionFetching}
                    icon={<IconDownload size={20} />}
                    className="ml-auto mb-2 bg-brand-600 border-brand-600 text-white dark:bg-brand-400 dark:border-brand-500 "
                    onClick={handlePrint}
                />
            </div>
            {/* Top Stats */}
            <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mb-6" ref={printRef}>

                {/* ---------- ROW 1 : 3 STAT CARDS ---------- */}
                {tripWiseSummaryStatistics.map((event, index) => (
                    <div className="md:col-span-3" key={event.label}>
                        <Card className="h-full" key={index}>
                            <div className={`pl-5 relative ${index === 0 ? "trip-summary-tooltip cursor-pointer" : ""
                                }`}>
                                <span
                                    className="absolute left-0 top-0 w-[.25rem] rounded-full h-full"
                                    style={{ backgroundColor: event.color }}
                                ></span>
                                {isTripSummaryStatisticsLoading ? (
                                    <>
                                        <Skeleton width="60%" height="1.5rem" className="mb-2" />
                                        <Skeleton width="40%" height="1.5rem" />
                                    </>
                                ) : (
                                    <>
                                        <p className="text-gray-700 dark:text-gray-100">{event.label}</p>
                                        <h2 className="text-3xl text-gray-900 dark:text-gray-100 font-bold">
                                            {event.value}
                                        </h2>
                                    </>
                                )}
                            </div>
                        </Card>
                    </div>
                ))}

                <div className="md:col-span-12">
                    <Card className="h-full" header={rfStrengthHeader}>
                        {isRFStrengthLoading ? (<div className="p-4">
                            <Skeleton width="100%" height="200px" borderRadius="10px" />
                        </div>
                        ) : (rfStrengthData?.response?.data?.length === 0 ? <div className="p-4 flex items-center justify-center h-64 font-medium">No Data Available</div> :
                            <LineChart isScroll id="trip-rf-over-time" data={formatChartData(rfStrengthData?.response?.data, 'rf')} xText={`Time (${rfStrengthData?.response?.resolution?.toLowerCase() ?? 'hour'})`} yText="Avg RF Strength (dBm)"
                                onRangeSelect={(start, end) => handleChartClick(start, end, true)} />
                        )}
                    </Card>
                </div>

                <div className="md:col-span-12">
                    <Card className="h-full" header={speedHeader}>
                        {isSpeedLoading ? (<div className="p-4">
                            <Skeleton width="100%" height="200px" borderRadius="10px" />
                        </div>
                        ) : ((speedData?.response?.data ?? initialData?.response?.data)?.length === 0 ? <div className="p-4 flex items-center justify-center h-64 font-medium">No Data Available</div> :
                            <LineChart isScroll id="trip-speed-over-time" data={formatChartData(speedData ? speedData?.response?.data : initialData?.response?.data, 'speed')} xText={`Time (${speedData ? speedData?.response?.resolution?.toLowerCase() : initialData?.response?.resolution?.toLowerCase()})`} yText="Avg Speed (Kmph)"
                                onRangeSelect={(start, end) => handleChartClick(start, end, false)} />
                        )}
                    </Card>
                </div>

                <div className="md:col-span-6">
                    <Card className="h-full" header="Events">
                        <DonutChart data={eventsDistributionData} className="h-86"
                            selectedEventInEventsDistributionChart={selectedEventInEventsDistributionChart}
                            // onSelect={(type) => {
                            //     if (type) {
                            //         setSelectedEventInEventsDistributionChart(type.toUpperCase());
                            //         setFirstEvent(0);
                            //         setRowsEvent(10);

                            //         setEventsQueryParams((prev: any) => ({
                            //             ...prev,
                            //             total_entry_per_page: 10,
                            //             page_num: 1,
                            //             eventCategories: type.includes('Brake')
                            //                 ? 'BRAKE_FAILURE'
                            //                 : type.replaceAll(' ', '_').toUpperCase()
                            //         }));

                            //     } else {
                            //         setSelectedEventInEventsDistributionChart('');
                            //         setFirstEvent(0);
                            //         setRowsEvent(10);

                            //         setEventsQueryParams((prev: any) => {
                            //             const { eventCategories, ...rest } = prev;
                            //             return rest;
                            //         });
                            //     }
                            // }}
                            id="events-distribution" />
                    </Card>
                </div>

                <div className="md:col-span-6">
                    <Card className="h-full" header="Health">
                        <DonutChart data={healthDistributionData} className="h-86" id="health-distribution" />
                    </Card>
                </div>

            </div>

            <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mb-6">
                <div className="md:col-span-6">
                    <Card header={eventsTimelineHeader} className="p-card-body-p-0 h-full">
                        <Table
                            columns={eventTableColumns}
                            data={eventTableData}
                            showGridlines={true}
                            paginator={true}
                            isLoading={isEventApiFetching}
                            first={firstEvent}
                            rows={rowsEvent}
                            totalRecords={totalEvents}
                            renderCell={(rowData, field, rowIndex) => {
                                if (field === 'eventCategory') {
                                    return <Tag value={rowData[field]} style={{
                                        backgroundColor: getEventColor(rowData[field]),
                                        borderColor: getEventColor(rowData[field]),
                                        color: '#fff'
                                    }}></Tag>
                                }
                                if (field === 'displayEventId') {
                                    return (
                                        <a id={`row-${rowIndex}`} className="underline cursor-pointer text-brand-600 dark:text-brand-50" onClick={() => handleEventView(rowData)}>
                                            {rowData[field] ?? '-'}
                                        </a>
                                    );
                                }
                            }}
                            onPageChangeExternal={(page_num, total_entry_per_page) => {
                                setFirstEvent((page_num - 1) * total_entry_per_page);
                                setRowsEvent(total_entry_per_page);
                                setEventsQueryParams((prev: any) => ({
                                    ...prev,
                                    page_num: page_num,
                                    total_entry_per_page: total_entry_per_page
                                }));
                            }}
                        />
                    </Card>
                </div>

                <div className="md:col-span-6">
                    <Card header={healthTimelineHeader} className="p-card-body-p-0 h-full">
                        <Table
                            columns={healthTableColumns}
                            data={healthTableData}
                            showGridlines={true}
                            paginator={false}
                            isLoading={isHealthTimelineFetching}
                            first={firstHealth}
                            rows={rowsHealth}
                            totalRecords={totalHealths}
                            renderCell={(rowData, field, rowIndex) => {
                                if (field === 'status') {
                                    return rowData[field] ? <Tag value={rowData[field]} severity={getSeverity(rowData[field])}></Tag> : '-'
                                }
                                if (field === 'parameter') {
                                    return (rowData['status'] ?
                                        <a id={`row-${rowIndex}`} className="underline cursor-pointer text-brand-600 dark:text-brand-50" onClick={() => buildFinalPath(rowData)}>
                                            {rowData[field]}
                                        </a> : rowData[field]
                                    );
                                }
                            }}
                            onPageChangeExternal={(page_num, total_entry_per_page) => {
                                setFirstHealth((page_num - 1) * total_entry_per_page);
                                setRowsHealth(total_entry_per_page);
                                setHealthTimelineQueryParams((prev: any) => ({
                                    ...prev,
                                    page_num: page_num,
                                    total_entry_per_page: total_entry_per_page
                                }));
                            }}
                        />
                    </Card>
                </div>
            </div>



        </div>
    );
}

export default TripWiseSummary;
